import type { PullRequestDiscussionInput } from "@afar-research/contracts";
import { pullRequestEnvironment } from "./state/pullRequests";
import { appAtomRegistry } from "./rpc/atomRegistry";
export async function executePullRequestDiscussion(input: PullRequestDiscussionInput) {
  const response = await pullRequestEnvironment.discuss.run(appAtomRegistry, {
    environmentId: input.environmentId,
    input,
  });
  if (response._tag === "Failure") throw new Error("Response lost");
  return response.value;
}
